module.exports = __webpack_public_path__ + "assets/img_plated.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_plated.jpg
 ** module id = 12
 ** module chunks = 1
 **/